<template>
<section class="p-3">
    <h3 class="text-white text-l font-bold uppercase">Coordinate data Item</h3>
    <div class="flex">
        <h5 class="text-xs text-white mr-3">Color: {{ color }}</h5>
        <h5 class="text-xs text-white mr-3">Thickness: {{ thickness }}</h5>
        <h5 class="text-xs text-white mr-3">Waypoints Resource Id: {{ waypoints_resource_id }}</h5>

        <h5 v-if="this.waypointFile()" class="text-xs text-white mr-3">Waypoints File: <a class="link" :href="this.waypointFile()" download>Download</a></h5>

        <h5 v-else class="text-xs text-white mr-3">Waypoints file for this language does not exists.
        <span v-if="form.coordinates_data.loaded_file_path && form.coordinates_data.current_waypoint_id == item.id" class="underline">{{ form.coordinates_data.loaded_file_path }}</span>
        </h5>

    </div>

    <div class="flex">
        <button @click.prevent="(e) => addWaypointFileForChange(e, item.id)" title="Edit" class="btn btn-xs btn-black mx-1">
            <i class="pen"></i>
        </button>
        <button v-if="this.waypointFile()" @click.prevent="(e) => deleteWaypoint(e, item.id)" title="Delete" class="btn btn-xs btn-black mx-1">
            <i class="trash"></i>
        </button>
    </div>
</section>
</template>

<script>
export default {
    components:{},
    props: [
        'item',
        'form',
        'changeUploadBoxState',
        'current_language',
        'deleteWaypoint'
    ],
    data(){
        return{
            color: this.item.color,
            thickness: this.item.thickness,
            waypoints_resource_id: this.item.waypoints_resource.id
        }
    },
    methods:{
        addWaypointFileForChange(e, id){
            this.form.coordinates_data.current_waypoint_id = id;
            this.changeUploadBoxState('waypoints');
        },
        waypointFile(){
            const current_language_file_pile = this.item.waypoints_resource.file_piles_localized.filter(el => el.language == this.form.current_language);

            let filepath;
            if(current_language_file_pile.length){
                filepath = current_language_file_pile[0].files[0].path;
                filepath = this.$page.props.s3_path+'/'+filepath;
            } else {
                filepath = null;
            }
            return filepath;
        }
    }
}
</script>
